'use client';

import Link from 'next/link';

interface StoriesActionIconsProps {
  onClick?: () => void;
  icon: React.ReactNode;
  isLink?: boolean;
  href?: string;
  className?: string;
}

export function StoriesActionIcons({
  onClick,
  icon,
  isLink,
  href,
  className,
}: StoriesActionIconsProps) {
  const baseClasses = 'flex size-10 cursor-pointer items-center justify-center rounded-full bg-surface';

  if (isLink && href) {
    return (
      <Link href={href} className={`${baseClasses} ${className || ''}`}>
        {icon}
      </Link>
    );
  }

  return (
    <div role="presentation" onClick={onClick} className={`${baseClasses} ${className || ''}`}>
      {icon}
    </div>
  );
}
